import { isNil, orderBy } from 'lodash';
import { filterNullMonths } from '../04_enrolmentCurveAndForecast/chartUtility';

class EnrolmentCurveAndTable {
  constructor() {
    this._enrolmentData = [];
    this._siteActivationData = [];
    this._forecastLSIDate = null;
    this._plannedLSIDate = null;
    this._forecastLSILowerBound = null;
    this._forecastLSIUpperBound = null;
    this._forecastLSIConfidenceInterval = null;
    this._screeningData = [];
    this._dropoutData = [];
    this._enrolledActualData = [];
    this._enrolledPlannedData = [];
  }

  set forecastLSILowerBound(value) {
    this._forecastLSILowerBound = value;
  }

  get forecastLSILowerBound() {
    return this._forecastLSILowerBound;
  }

  set forecastLSIUpperBound(value) {
    this._forecastLSIUpperBound = value;
  }

  get forecastLSIUpperBound() {
    return this._forecastLSIUpperBound;
  }

  set forecastLSIConfidenceInterval(value) {
    this._forecastLSIConfidenceInterval = value;
  }

  get forecastLSIConfidenceInterval() {
    return this._forecastLSIConfidenceInterval;
  }

  set enrolmentData(dataItems) {
    const sortedDataItems = orderBy(dataItems, ['trialMonth'], ['asc']);
    const filteredDataItems = filterNullMonths(sortedDataItems);
    this._enrolmentData = filteredDataItems.map((dataItem) => {
      const cleanedDataItems = this._cleanTrialDataDates(dataItem);
      const returnData = { ...cleanedDataItems, isEnrollmentApi: true };
      return returnData;
    });
  }

  get enrolmentData() {
    return this._enrolmentData;
  }

  set siteActivationData(dataItems) {
    const sortedDataItems = orderBy(dataItems, ['trialMonth'], ['asc']);

    const filteredDataItems = filterNullMonths(sortedDataItems);
    this._siteActivationData = filteredDataItems.map((dataItem) => {
      const cleanedDataItems = this._cleanTrialDataDates(dataItem);
      const returnData = { ...cleanedDataItems, isActivationApi: true };
      return returnData;
    });
  }

  get siteActivationData() {
    return this._siteActivationData;
  }

  set screeningData(dataItems) {
    const sortedDataItems = orderBy(dataItems, ['trialMonth'], ['asc']);
    const filteredDataItems = filterNullMonths(sortedDataItems);

    this._screeningData = filteredDataItems.map((dataItem) => {
      const cleanedDataItems = this._cleanTrialDataDates(dataItem);
      const returnData = { ...cleanedDataItems, isEnrollmentApi: true };
      return returnData;
    });
  }

  get screeningData() {
    return this._screeningData;
  }

  set dropoutData(dataItems) {
    const sortedDataItems = orderBy(dataItems, ['trialMonth'], ['asc']);

    const filteredDataItems = filterNullMonths(sortedDataItems);
    this._dropoutData = filteredDataItems.map((dataItem) => {
      const cleanedDataItems = this._cleanTrialDataDates(dataItem);
      const returnData = { ...cleanedDataItems, isEnrollmentApi: true };
      return returnData;
    });
  }

  get dropoutData() {
    return this._dropoutData;
  }

  set enrolledActualData(dataItems) {
    const sortedDataItems = orderBy(dataItems, ['trialMonth'], ['asc']);

    const filteredDataItems = filterNullMonths(sortedDataItems);
    this._enrolledActualData = filteredDataItems.map((dataItem) => {
      const cleanedDataItems = this._cleanTrialDataDates(dataItem);
      const returnData = { ...cleanedDataItems, isEnrollmentApi: true };
      return returnData;
    });
  }

  get enrolledActualData() {
    return this._enrolledActualData;
  }

  set enrolledPlannedData(dataItems) {
    const sortedDataItems = orderBy(dataItems, ['trialMonth'], ['asc']);

    const filteredDataItems = filterNullMonths(sortedDataItems);
    this._enrolledPlannedData = filteredDataItems.map((dataItem) => {
      const cleanedDataItems = this._cleanTrialDataDates(dataItem);
      const returnData = { ...cleanedDataItems, isEnrollmentApi: true };
      return returnData;
    });
  }

  get enrolledPlannedData() {
    return this._enrolledPlannedData;
  }

  _cleanTrialDataDates(dataItem) {
    let { trialMonth } = dataItem;
    if (!isNil(trialMonth)) {
      const trialMonthParts = trialMonth.split('-');
      trialMonthParts[2] = '01';
      trialMonth = trialMonthParts.join('-');
    }
    return { ...dataItem, trialMonth };
  }
}
export default EnrolmentCurveAndTable;
